import React from 'react';
var ToastContext = /*#__PURE__*/React.createContext(null);
var ToastContextProvider = ToastContext.Provider;
var ToastContextConsumer = ToastContext.Consumer;
export { ToastContext, ToastContextConsumer, ToastContextProvider };